import cn from "classnames";
import Tooltip from "rc-tooltip";
import React from "react";

const ExpressBidIcon = ({ className, placement = "bottom" }) => (
    <Tooltip overlay="Экспресс-заявка" placement={placement}>
        <i className={cn("icon-uEA90-bolt b-table__compound-icon pr-1", className)} />
    </Tooltip>
);

export default ExpressBidIcon;
